<du-notification-toast
  *ngFor="let toast of toasts$ | async; trackBy: trackById"
  [notification]="toast"
  [closeAriaLabel]="closeAriaLabel"
  (dismissed)="dismissed.emit($event)"
  (actionInvoked)="actionInvoked.emit($event)"
>
</du-notification-toast>
